export type ISizes = '200x112' | '310x200' | '520x290' | '520x' | '780x' | 'x290';

export default (url: string, size: ISizes) => {
    const splittedUrl = url.split('.ru/');

    return `${splittedUrl[0]}.ru/resize/${size}/${splittedUrl[1]}`;
};
